import config from '../config';

export function getImageUrl(product) {
  return getImageUrls(product)[0] || '';
}

export function getImageUrls(product) {
  const images = [], visited = new Set();
  const add = value => { const url = imagePath(value); if (url && !images.includes(url)) images.push(url); };
  const visit = (value, depth = 0) => {
    if (!value || depth > 3) return;
    if (typeof value === 'string') { add(value); return; }
    if (typeof value !== 'object' || visited.has(value)) return;
    visited.add(value);
    add(value.imageUrl); add(value.image_url); add(value.product_image_url);
    for (const field of [value.imageUrls, value.image_urls]) {
      let urls = field;
      if (typeof urls === 'string') { try { urls = JSON.parse(urls); } catch { urls = [urls]; } }
      if (Array.isArray(urls)) urls.forEach(add);
    }
    visit(value.product, depth + 1);
    visit(value.orderItem, depth + 1);
    visit(value.variant?.product, depth + 1);
  };
  visit(product);
  return images;
}

function imagePath(value) {
  if (typeof value !== 'string') return '';
  const image = value.trim();
  if (!image || /^(?:null|undefined|\[object Object\])$/i.test(image) || image.startsWith('//') || /[<>\\]/.test(image)) return '';
  if (/^https?:\/\//i.test(image)) {
    try { const url = new URL(image); return url.username || url.password ? '' : url.href; } catch { return ''; }
  }
  if (/^[a-z][a-z\d+.-]*:/i.test(image) || /^[\[{]/.test(image) || image.includes('..')) return '';
  if (image.startsWith('/')) return `${config.API_URL}${image}`;
  if (image.startsWith('uploads/')) return `${config.API_URL}/${image}`;
  return `${config.UPLOADS_URL}/${image}`;
}
